<template>
  <div class="card shadow-sm border-0 rounded-custom mt-4">
    <div class="card-body p-4 text-center">
      <h3 class="text-violet text-uppercase mb-3">{{ $t("Photo from smartphone") }}</h3>
      <p class="text-muted small mb-3">
        {{ $t("Scan the QR code with the department smartphone to upload the production photo.") }}
      </p>

      <div class="d-flex justify-content-center mb-3">
        <QRCode :text="qrUrl" class="m-auto" />
      </div>

      <div class="small text-muted mb-3">
        {{ $t("Link valid until") }} {{ formattedExpiry }}.
      </div>

      <div v-if="photoAttached" class="alert alert-success small mb-0">
        {{ $t("Photo correctly attached to the record.") }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import QRCode from "@/components/QRCode.vue";

export default {
  name: "CamProductionQrHelper",
  components: {
    QRCode,
  },
  props: {
    qrUrl: {
      type: String,
      required: true,
    },
    expiresAt: {
      type: String,
      default: null,
    },
    photoAttached: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const i18n = useI18n();
    const formattedExpiry = computed(() => {
      if (!props.expiresAt) return i18n.t("Soon");

      return new Date(props.expiresAt).toLocaleString("it-IT");
    });

    return {
      formattedExpiry,
    };
  },
};
</script>
